import React,{useState} from "react";

/* Innholdet i hoeyreklikk-popupen paa kartet. Objektene kommer fra flisene
   (queryRenderedFeatures i drawUtils), ikke fra API-et: Martin publiserer alle
   kolonnene i uploads-tabellen, og tippecanoe filtrerer ingen attributter bort,
   saa alt som skal vises her ligger allerede i laget som er tegnet.

   Popupen kjenner derfor bare det som er synlig naa. Paa lave zoomnivaaer har
   tippecanoe droppet objekter (--drop-densest-as-needed), og da finnes de
   heller ikke her. Det er grunnen til hintet i tom-tilstanden.

   Hvert objekt er et eget sammenleggbart kort, ikke en rad med en tabell under.
   Det er det som gjoer at to treff i samme lag leses som to objekter — med en
   flat liste var det ikke til aa se hvor det ene sluttet og det andre begynte. */

/* Antall attributter som vises foer "Show all". */
const PRIMARY_ATTRS = 6;

const attrValue = (v) => (v === null || typeof v === 'undefined' || v === '') ? '—' : String(v);

export default function FeaturePopup({groups, coords, onCopyCoords, onClose}) {

	/* Foerste laget staar aapent med foerste objekt utvidet: er det bare ett
	   treff, er det som regel det brukeren hoeyreklikket for aa se. */
	const [expanded, setExpanded]	= useState(groups.length ? {[groups[0].id]: true} : {});
	const [openFeature, setOpen]	= useState(groups.length && groups[0].features.length ? {[groups[0].id]: 0} : {});
	const [showAll, setShowAll]		= useState({});

	const featureCount = groups.reduce((n, g) => n + g.features.length, 0);

	const headline = groups.length
		? featureCount + (featureCount === 1 ? ' feature' : ' features') + ', ' + groups.length + (groups.length === 1 ? ' layer' : ' layers')
		: 'No features here';

	const toggleGroup = (g) => {
		setExpanded((s) => ({...s, [g.id]: !s[g.id]}));
		setOpen((s) => (typeof s[g.id] === 'undefined' ? {...s, [g.id]: 0} : s));
	};

	/* Ett aapent objekt om gangen per lag — klikker du det aapne, lukkes det. */
	const toggleFeature = (g, i) => setOpen((s) => ({...s, [g.id]: s[g.id] === i ? null : i}));

	return (
		<div className="feature-popup">
			<div className="fp-head">
				<div className="fp-head-text">
					<div className="fp-headline">{headline}</div>
					<div className="fp-coords" onClick={onCopyCoords} title="Copy to clipboard">
						<i className="ri-file-copy-line"></i>
						<span>{coords}</span>
					</div>
				</div>
				<div className="fp-close" onClick={onClose} title="Close">×</div>
			</div>

			{!groups.length &&
				<div className="fp-empty">
					No vector features at this point.<br />
					Try right-clicking a data layer, or zoom in — dense layers are thinned out at low zoom.
				</div>
			}

			{!!groups.length &&
				<div className="fp-groups">
					{groups.map((g) => {

						const groupOpen = !!expanded[g.id];

						return (
							<div className="fp-group" key={g.id}>
								<div className="fp-group-head" onClick={() => toggleGroup(g)}>
									<span className="fp-arrow">{groupOpen ? '▾' : '▸'}</span>
									<span className="fp-swatch" style={{background: g.color}}></span>
									<span className="fp-group-name" title={g.name}>{g.name}</span>
									<span className="fp-count">{g.features.length}</span>
								</div>

								{groupOpen &&
									<div className="fp-features">
										{g.features.map((f, i) => {

											const open		= openFeature[g.id] === i;
											const allKey	= g.id + '#' + i;
											const all		= !!showAll[allKey];
											const rows		= all ? f.attrs : f.attrs.slice(0, PRIMARY_ATTRS);

											return (
												<div className={"fp-feature" + (open ? " open" : "")} key={i}>

													<div className="fp-feature-head" onClick={() => toggleFeature(g, i)}>
														<span className="fp-arrow">{open ? '▾' : '▸'}</span>
														<span className="fp-feature-title" title={f.title}>{f.title}</span>
													</div>

													{open &&
														<>
															<div className="fp-attr-grid">
																{rows.map(([k, v], r) => (
																	<React.Fragment key={r}>
																		<div className="fp-attr-key" title={k}>{k}</div>
																		<div className="fp-attr-val">{attrValue(v)}</div>
																	</React.Fragment>
																))}
															</div>
															{f.attrs.length > PRIMARY_ATTRS &&
																<div className="fp-attr-more" onClick={() => setShowAll((s) => ({...s, [allKey]: !s[allKey]}))}>
																	{all ? 'Show fewer ▴' : 'Show all ' + f.attrs.length + ' attributes ▾'}
																</div>
															}
														</>
													}
												</div>
											);
										})}
									</div>
								}
							</div>
						);
					})}
				</div>
			}
		</div>
	);
}
